export default __webpack_public_path__ + "static/media/deadlydraw.e2f3b5d7.png";